interface Props {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "center" | "left";
  action?: React.ReactNode;
}

export default function SectionHeading({ eyebrow, title, desc, align = "center", action }: Props) {
  const alignCls = align === "center" ? "text-center items-center" : "text-left items-start";
  return (
    <div className={`mb-10 flex flex-col gap-3 ${alignCls}`}>
      <span className="text-sm font-medium tracking-wide text-primary-500">{eyebrow}</span>
      <h2 className="font-heading text-3xl text-foreground-900">{title}</h2>
      {desc && <p className="max-w-xl text-sm text-foreground-500">{desc}</p>}
      {action}
    </div>
  );
}